import { render, staticRenderFns } from "./compoundList.vue?vue&type=template&id=4d92759c&scoped=true"
import script from "./compoundList.vue?vue&type=script&lang=js"
export * from "./compoundList.vue?vue&type=script&lang=js"
import style0 from "./compoundList.vue?vue&type=style&index=0&id=4d92759c&prod&scoped=true&lang=scss"
import style1 from "./compoundList.vue?vue&type=style&index=1&id=4d92759c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92759c",
  null
  
)

export default component.exports